module.exports = __webpack_public_path__ + "static/media/freadom_login.50cfe676.png";